import React from "react";

function WhatIsDEX() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is DEX Aggregator?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A DEX (Decentralized Exchange) aggregator is a platform or
                  protocol that sources liquidity from multiple decentralized
                  exchanges, allowing users to access the best prices and lowest
                  slippage on their trades. Instead of a trader manually
                  checking different exchanges for optimal rates, a DEX
                  aggregator automates this by scanning multiple DEXs and
                  executing the trade across the best combination of them to
                  ensure the best outcome in terms of price, liquidity, and
                  transaction fees.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="/contact-us">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatIsDEX;
